var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollbarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 1332,
    viewBox: "0 0 16 1332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8V1324C16 1328.42 12.4183 1332 8 1332C3.58172 1332 0 1328.42 0 1324V8Z",
    fill: "#EBEAEB",
    fillOpacity: 0.603922
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollbarBg);
export default __webpack_public_path__ + "static/media/scrollbar-bg.68fc2faf3ff405184b755b4cb6cb3cff.svg";
export { ForwardRef as ReactComponent };